<template>
<div class="chapter">
<div class="inner_page">
<p class="ctfm-alt"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a href="#/xhtml/06_Editor#edt" id="edt">Editor’s Note</a></p>
<p class="toc"><a href="#/xhtml/07_Introduction#int" id="int">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/07_Introduction#int"><i>It All Turns on Sentiment: John Crowe Ransom, Aesthetics, and Agrarian Economics</i></a></p>
<p class="tocau">Jay T. Collier</p>
<p class="bkau1"><img alt="Image" src="images/lin2.jpg"/></p>
<p class="toc"><span href="#/xhtml/08_Fm01#Fm1" id="Fm1" title="Link target outside of Sample"><i>Land! The Case for an Agrarian Economy</i></span></p>
<p class="toc"><span href="#/xhtml/09_Preface#pre" id="pre" title="Link target outside of Sample">Preface</span></p>
<p class="tocf"><span href="#/xhtml/10_Chapter01#ch1" id="ch1" title="Link target outside of Sample">Chapter 1. Homeless People and Vacant Land</span></p>
<p class="tocf"><span href="#/xhtml/11_Chapter02#ch2" id="ch2" title="Link target outside of Sample">Chapter 2. The Excess of Capital</span></p>
<p class="tocf"><span href="#/xhtml/12_Chapter03#ch3" id="ch3" title="Link target outside of Sample">Chapter 3. Some Proposed Extinguishers</span></p>
<p class="tocf"><span href="#/xhtml/13_Chapter04#ch4" id="ch4" title="Link target outside of Sample">Chapter 4. The Amphibian Farmer</span></p>
<p class="toc"><span href="#/xhtml/14_Appendix01#app" id="app" title="Link target outside of Sample">Appendix: The State and the Land</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?239ac38a